import React, { useEffect, useState } from "react";
import sanityClient from "../client.js";
import AboutImg from "../mustang.jpg";
import BlockContent from "@sanity/block-content-to-react";

import imageURLBuilder from "@sanity/image-url";

const builder = imageURLBuilder(sanityClient);
function urlFor(source){
    return builder.image(source);
}

export default function About(){
    const [author, setAuthor] = useState(null);

    useEffect(() => {
        sanityClient.fetch(`*[_type == "author"]{
            name,
            bio,
            "authorimage" : image.asset->url
        }`).then((data) => setAuthor(data[0]))
        .catch(console.error);
    },[]);

    if(!author) return <div>Loading...</div>
    return (
        <main className="relative">
            <img src={AboutImg} alt="Mustang" className="absolute w-full"/>
            <div className="p-10 lg:pt-48 container mx-auto relative">
                <section className="bg-green-800 rounded-lg shadow-2xl lg:flex p-20">
                    <img src={urlFor(author.authorimage).url()} className="rounded w-32 h-32 lg:w-64 lg:h-64 mr-8"
                    alt={author.name} />
                    <div className="text-lg flex flex-col justify-center">
                        <h1 className="cursive text-6xl text-green-300 mb-4">
                            Hey there.I'm {" "}
                            <span className="text-green-100"> {author.name}</span>
                        </h1>
                        <div className="px-16 lg:px-48 py-12 lg:py-20 prose lg:prose-xl max-w-full">
                            <BlockContent 
                            blocks={author.bio}
                            projectId = "171195p7"
                            dataset="production"/>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    )
}